// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"f97f5010","241":"2804efbc","287":"a5aa017e","446":"32b16882","460":"84362f36","488":"22b449f6","597":"cd5ade36","728":"05d50e2f","730":"51c41717","829":"7395da9c","969":"64261927","979":"9dfb46f1"}[chunkId] + ".chunk.js";
};